import React from 'react';

import DealField, { propTypes } from './field';
import ManagedCheckbox from 'components/form/managed_input/checkbox';

export function CheckboxDealField({ changeDeal, deal, label, name }) {
  return (
    <ManagedCheckbox
      label={label}
      name={name}
      value={deal[name] === true || deal[name] === 'Yes'}
      wrapperClassName="form-group"
      onChange={changeDeal}
      onValueChange={() => { }}
    />
  );
}

CheckboxDealField.propTypes = propTypes;

export default DealField(CheckboxDealField);
